import * as v from 'valibot';
import { integerInRange, dateStringSchema } from '../util/valibot';
export const mandolynSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    title: v.string(),
    comment: v.string(),
    code: v.string(),
    created: dateStringSchema,
});
